export const BELLHOPT_ORGANIZATION_ID = "https://www.bellhopt.com/#organization";
export const ALEXANDER_ALI_PERSON_ID = "https://www.bellhopt.com/#alexander-ali";
export const BELLHOPT_HOMEPAGE_WEBPAGE_ID = "https://www.bellhopt.com/#webpage";
export const BELLHOPT_WEBSITE_ID = "https://www.bellhopt.com/#website";

export function organizationRef() {
  return { "@id": BELLHOPT_ORGANIZATION_ID };
}

export function personRef() {
  return { "@id": ALEXANDER_ALI_PERSON_ID };
}
